import * as React from "react";
import {useEffect, useState} from "react";
import {Box, Container} from "@mui/material";
import Navbar from "./navbar";
import AdminFooter from "./footer";
import {FeedbackButton} from "../feedback/feedback_button";
import {useAuthManager} from "../utils/auth";

import {useNavigate} from "react-router-dom";
import {useApiManager} from "../utils/api";
import {LOGIN_URL} from "../utils/urls";
import {UserAuth, UserRestControllerApiFactory} from "arteco-api-client-ts";
import {AxiosResponse} from "axios";


export interface AppLayoutProps {
    children?: React.ReactNode;
    permitAnon?: boolean;
    maxWidth?: 'xs'
        | 'sm'
        | 'md'
        | 'lg'
        | 'xl'
}

export const AppLayout = (props: AppLayoutProps) => {
    const authManager = useAuthManager();
    const apiManager = useApiManager();
    const router = useNavigate();
    const [logging, setLogging] = useState<boolean>(true);

    useEffect(() => {
        if (props.permitAnon == true) {
            setLogging(false);
            return;
        }

        if (authManager.isLogged()) {
            setLogging(false);
            return;
        }

        // Try to fetch user info from API (session might be active)
        const api = apiManager.factory(UserRestControllerApiFactory);
        apiManager.executeRaw(api.info(), undefined, true).then((resp: AxiosResponse<UserAuth>) => {
            authManager.saveUser(resp.data);
            try {
                const redirectUrl = localStorage.getItem("login_redirect_url");
                if (redirectUrl) {
                    localStorage.removeItem("login_redirect_url");
                    router(redirectUrl);
                }
            } catch {}
            setLogging(false);
        }).catch(() => {
            // info() falló: o bien es un 401 que executeRaw ya encaminó a /login, o bien
            // un error de red / respuesta cross-origin bloqueada que no puede clasificar
            // (típico al entrar por una URL profunda sin sesión). En ese segundo caso
            // executeRaw no hace nada y quedaríamos en "Loading..." para siempre.
            // Encaminamos por /login (idempotente si ya se navegó) recordando la URL
            // profunda, para que allí arranque el flujo OAuth y vuelva aquí al terminar.
            try {
                if (window.location.pathname !== LOGIN_URL && window.location.pathname !== "/logout") {
                    const currentUrl = window.location.pathname + window.location.search;
                    localStorage.setItem("login_redirect_url", currentUrl);
                }
            } catch {}
            router(LOGIN_URL);
        });

    }, []);


    return (
        <Box sx={{backgroundColor: "rgb(231, 235, 240)", height: "100%"}}>
            <Navbar/>
            {logging && (
                <>
                    <Container maxWidth={"md"}>
                        <Box my={5}>
                            <span>
                                Loading...
                            </span>
                        </Box>
                    </Container>

                </>
            )}
            {!logging && (
                <Box my={3}>
                    {!props.maxWidth && (
                        <>
                            {props.children}
                        </>
                    )}
                    {props.maxWidth && (
                        <Container maxWidth={props.maxWidth}>
                            {props.children}
                        </Container>
                    )}
                </Box>
            )}
            <AdminFooter/>
            {/* Avisar de un problema (#13892): solo con sesión, en todo el admin y el portal. */}
            {!logging && !props.permitAnon && <FeedbackButton/>}
        </Box>
    );
};
